module.exports = __webpack_public_path__ + "img/wechat-qr.28b0aa70.png";